import ruLocale from "antd/es/locale/ru_RU";
import uaLocale from "antd/es/locale/uk_UA";
import "moment/dist/locale/uk";
import "moment/dist/locale/ru";
import type { Resource } from "i18next";
import moment from "moment";
import type { Locale } from "antd/es/locale-provider";
import { isBackend } from "config";

export const antLocales: Record<string, Locale> = { ru: ruLocale, ua: uaLocale };

export const initLocalization = async (lang: string) => {
  // const cacheBust = "?" + Date.now();

  if (isBackend) {
    const [i18n, { initReactI18next }, ua, ru] = await Promise.all([
      import("i18next"),
      import("react-i18next"),
      import("./resources/locales/ua.json"),
      import("./resources/locales/ru.json"),
      import("./resources/locales/en.json"),
    ]);
    const resources: Resource = { ua, ru };

    await i18n.use(initReactI18next).init({
      resources,
      lng: lang,
      fallbackLng: "ru",
      interpolation: {
        escapeValue: false,
      },
    });
  } else {
    const [i18n, { initReactI18next }] = await Promise.all([
      import("i18next"),
      import("react-i18next"),
    ]);

    await i18n.use(initReactI18next).init({
      resources: {},
      lng: lang,
      fallbackLng: "ru",
      interpolation: {
        escapeValue: false,
      },
      react: {
        bindI18nStore: "added",
      },
    });
  }

  moment.locale(lang === "ua" ? "uk_UA" : "ru_RU");
};
